import { render, staticRenderFns } from "./OtpuskConfirmation.vue?vue&type=template&id=153fe4ac&"
import script from "./OtpuskConfirmation.vue?vue&type=script&lang=js&"
export * from "./OtpuskConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports